import axios from 'axios'

export const API = (token) => {
    return axios.create({
        // baseURL: 'http://localhost:8080/api',
        baseURL: 'https://kings-logix.ru/api',
        responseType: 'json',
        headers: {
            'X-Custom-Header': 'foobar',
            Authorization: `Bearer ${token}`,
        },
    })
}
